import { Component, ViewChild, Inject, inject, DestroyRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface UserData {
  user_id: any;
  data: any;
}

export interface UserElement {
  UserID: string;
  UserName: string;
  Mobile: string;
  created_date: any;
  // Password: string;
  events: any;
  so_events: any;
}

export interface EventElement {
  event_id: string;
  event_name: string;
  event_type: string;
  description: string;
  address: string;
  user_mobile: string;
  user_pwd: string;
  user_name: string;
  from_date: string;
  to_date: string;
  event_logo: string;
  event_image: string;
  from_time: string;
  to_time: string;
  is_active: string;
  action: any;
}

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  standalone: false,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ],
})
export class UserComponent {
  displayedColumns: string[] = [
    'UserID',
    'UserName',
    'Mobile',
    'created_date',
    // 'Password',
    // 'action',
  ];
  columnsToDisplayWithExpand = [...this.displayedColumns, 'expand'];
  expandedElement!: EventElement | null;

  ELEMENT_DATA: UserElement[] = [];
  user_result: any;
  user_type: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<UserElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  user_id: any;
  event_result: any;
  event_name: any;
  event_type: any;
  description: any;
  address: any;
  user_mobile: any;
  user_pwd: any;
  user_name: any;
  from_date: any;
  to_date: any;
  event_logo: any;
  event_image: any;
  from_time: any;
  to_time: any;
  is_active: any;
  action: any;
  event_id: any;
  filterValue: string = '';
  user_count: any;

  constructor(private service: ServicesService,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngAfterViewInit() {
    this.Get_User('all');
    this.dataSource.paginator = this.paginator;
  }

  Add_User() {
    const dialogRef = this.dialog.open(add_edit_user, {
      data: {
        user_id: this.user_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_User('all');
    });
  }

  Edit_User(user_id: any) {
    const dialogRef = this.dialog.open(add_edit_user, {
      data: {
        user_id: user_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_User('all');
    });
  }

  View_Event(user_id: any) {
    const dialogRef = this.dialog.open(view_event, {
      data: {
        user_id: user_id
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_User('all');
    });
  }

  Go(user_id: any, mobile: any) {
    console.log(user_id);

    this.service.login_otp(mobile).subscribe(
      (data: any) => {
        if (data.flag == true) {
          const Login_Data = data.role;

          if (Login_Data === 'superadmin') {
            sessionStorage.setItem('User', 'superadmin');
            sessionStorage.setItem('User_ID', data.user_id);
            this.router.navigateByUrl('/admin/Dashboard');
          } else if (Login_Data === 'admin' || Login_Data === 'subadmin' || Login_Data === "stallowner" || Login_Data === "user") {
            // sessionStorage.setItem('User', Login_Data);
            // sessionStorage.setItem('User_ID', data.user_id);
            // this.router.navigateByUrl('/admin/Dashboard');

            const url = this.router.serializeUrl(
              this.router.createUrlTree(['/admin/Dashboard'], {
                queryParams: { User_ID: data.user_id, User: Login_Data }
              })
            );

            const basePath = window.location.pathname.split('/')[1];
            // gets 'scan-me' if present (web version path)

            const finalUrl = window.location.origin +
              (basePath ? '/' + basePath : '') +
              '/#' + url;

            window.open(finalUrl, '_blank');
          } else {
            alert(data.msg);
          }
        } else {
          alert(data.msg);
        }
      },
      (error: any) => {
        // Handle the error scenario
        console.error('Login request failed:', error);
        alert('Login failed: ' + (error.message || 'Unknown error'));
      });
  }

  copySoLink(so_id: any) {
    const link = `https://aieventzo.com/product_catalogue.html?so_id=${so_id}`;
    navigator.clipboard.writeText(link);
    this.toastr.success('Link Copied!');
  }

  Get_User(user_type: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_user(user_type).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.user_result = data.data;
        if (this.user_result) {
          for (const item of this.user_result) {

            const date = new Date(item.created_date);

            this.ELEMENT_DATA.push({
              UserID: item.user_id,
              Mobile: item.user_mobile,
              UserName: item.user_name,
              // Password: item.user_pwd,
              created_date: !isNaN(date.getTime())
                ? `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')
                }/${date.getFullYear()}`
                : '',
              events: item.events,
              so_events: item.so_events
              // action: item.user_id
            });
          }
          this.spinner.hide();
        }
        this.dataSource = new MatTableDataSource<UserElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Event(user_id: any) {
    this.service.get_event_by_user(user_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        this.event_result = data.data
        this.event_id = this.event_result.event_id,
          this.event_name = this.event_result.event_name,
          this.event_type = this.event_result.event_type,
          this.description = this.event_result.description,
          this.address = this.event_result.address,
          this.user_mobile = this.event_result.user_mobile,
          this.user_pwd = this.event_result.user_pwd,
          this.user_name = this.event_result.user_name,
          this.from_date = this.event_result.from_date,
          this.to_date = this.event_result.to_date,
          this.event_logo = this.event_result.event_logo,
          this.event_image = this.event_result.event_image,
          this.from_time = this.event_result.from_time,
          this.to_time = this.event_result.to_time,
          this.is_active = this.event_result.is_active,
          this.action = this.event_result.event_id
      }
    );
  }

  DeleteUser(user_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This User?');
    if (buttonClicked === true) {
      this.service.delete_user(user_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.toastr.success('User Deleted Successfully');
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.UserID !== user_id);
          this.dataSource.data = this.ELEMENT_DATA;
        });
    }
  }

  onTabChange(event: any): void {
    const user_type = event.index === 0 ? 'all' : 'admin';
    this.filterValue = '';
    this.Get_User(user_type);
  }

}


@Component({
  templateUrl: 'add_edit_user.html',
  selector: 'add_edit_user.html',
  styleUrls: ['./user.component.scss'],
  standalone: false
})

export class add_edit_user {
  UserForm: FormGroup;
  user_id: any;
  user_name: any;
  user_mobile: any;
  user_pwd: any;
  is_active: any = '1';
  result: any;
  main: any;
  isResetMode = false;
  private destoryRef = inject(DestroyRef);

  constructor(
    private service: ServicesService,
    private formbuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<add_edit_user>,
    @Inject(MAT_DIALOG_DATA) public data: UserData
  ) {
    this.user_id = data['user_id'];
    this.UserForm = this.formbuilder.group({
      user_id: this.user_id,
      user_name: '',
      user_mobile: new FormControl('', [Validators.required]),
      user_pwd: new FormControl('', [Validators.required]),
      is_active: '',
    });
  }

  ngOnInit() {
    this.getUserById(this.user_id);
  }

  resetPassword() {
    this.isResetMode = true;

    // Enable field
    this.UserForm.get('user_pwd')?.enable();

    // Clear old value
    this.UserForm.patchValue({
      user_pwd: ''
    });
  }

  getUserById(user_id: any) {
    this.service.get_user_by_id(user_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        if (data.flag == true) {
          console.log(this.isResetMode);
          
          this.result = data;
          this.main = this.result.data;
          this.user_id = this.main?.[0].user_id;
          this.user_name = this.main?.[0].user_name;
          this.user_mobile = this.main?.[0].user_mobile;
          this.user_pwd = this.main?.[0].user_pwd;
          this.is_active = this.main?.[0].is_active ? this.main?.[0].is_active : '1';
        } else {
          this.isResetMode = true
        }
      }
    );
  }

  onFormSubmit() {
    if (this.UserForm.valid) {
      if (this.user_id) {
        const formData = { ...this.UserForm.value, isResetMode: this.isResetMode };
        this.service.edit_user(formData).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("User Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_user(this.UserForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("User Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    }
  }
}

@Component({
  templateUrl: 'view_event.html',
  selector: 'view_event.html',
  styleUrls: ['./user.component.scss'],
  standalone: false
})

export class view_event {

  user_id: any;

  constructor(
    private service: ServicesService,
    private router: Router,
    private formbuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<add_edit_user>,
    @Inject(MAT_DIALOG_DATA) public data: UserData
  ) {
    this.user_id = data['user_id'];
  }

  displayedColumns: string[] = [
    'event_id',
    'event_name',
    'event_type',
    'address',
    'from_date',
    'to_date',
    'event_logo',
    'event_image',
    'from_time',
    'to_time',
    'is_active',
    // 'description',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  event_result: any;
  dataSource: any;
  paginator: any;
  sort: any;

  ngOnInit() {
    this.Get_Event();
  }

  Get_Event() {
    this.ELEMENT_DATA = [];
    this.service.get_event_by_user(this.user_id).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            event_id: item.event_id,
            event_name: item.event_name,
            event_type: item.event_type,
            description: item.description,
            address: item.address,
            user_mobile: item.user_mobile,
            user_pwd: item.user_pwd,
            user_name: item.user_name,
            from_date: item.from_date,
            to_date: item.to_date,
            event_logo: `https://aieventzo.com/upload/event_logo/` + item.event_logo,
            event_image: `https://aieventzo.com/upload/event_image/` + item.event_image,
            from_time: item.from_time,
            to_time: item.to_time,
            is_active: item.is_active,
            action: item.event_id
          });
        }
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
      }
    );
  }

  DeleteEvent(event_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Event? ');
    if (buttonClicked === true) {
      this.service.delete_event(event_id).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.event_id !== event_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Event Deleted Succesfully");
        });
    }
  }

  Add_Event() {
    this.router.navigate(['/admin/Events/AddEvent', { 'user_id': this.user_id }]);
    this.dialogRef.close(true);
  }

  Edit_Event(event_id: any) {
    this.router.navigate(['/admin/Events/EditEvent', { 'event_id': event_id }]);
    this.dialogRef.close();
  }

}